export let config = {
  platId: '1005', //分销商平台
  //platId: '1003',//思客商旅平台id
  distributionWebsite: [
    'uatparter.ceekee.com',
    'uatebooking.ceekee.com',
    '192.168.120.223',
    'partner.ceekee.com',
    '192.168.0.45',
    'fatmanage.ceekee.com',
  ],
  noShowEnterpriseId: [746728], // 不展示资源预定、结算管理菜单，消费场景收费标准内容企业
};
